<div class="bfd-dropdown-wrapper">
  <button class="bfd-dropdown-toggle" (click)="toggleDropdown()">
    {{ buttonLabel }}
    <img
      [class.rotate]="hasOpened"
      src="assets/svg/chevron.svg"
      alt="Seta"
    />
  </button>

  <div *ngIf="hasOpened" class="bfd-dropdown-menu">
    <div
      *ngFor="let item of items"
      class="bfd-dropdown-item"
      (click)="onSelect(item)"
    >
      {{ item.name }}
    </div>
  </div>
</div>